import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useFormState } from "react-final-form";
import { noop } from "lodash";
import classNames from "classnames";
import Input from "rs-components/Input";
import SearchSelectInput from "rs-components/Input/components/SearchSelectInput";
import InsightInputSelect from "./components/InsightInputSelect";
import InsightOutputSelect from "./components/InsightOutputSelect";
import { FormField } from "../../index";
import { isEditableSelector } from "store/knowledge-base-item/knowledge-base-item.selectors";
import { completedWorkspaceInsightsOptionsSelector } from "store/rs-workspace/selectors/rs-workspace.selectors";
import * as styles from "../../styles.module.scss";
const InsightParameterFormField = ({ selectedParameters, restrictions = {} }) => {
    const formState = useFormState();
    const { insightId, inputSetId } = useMemo(() => ({ ...formState.values }), [formState.values]);
    const editable = useSelector(isEditableSelector);
    const insightOptions = useSelector(completedWorkspaceInsightsOptionsSelector(insightId));
    const selectedInsightOption = useMemo(() => insightOptions.find(({ value }) => value === insightId), [insightId, insightOptions]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.field },
            React.createElement(Input, { component: SearchSelectInput, readonly: !editable || !insightOptions.length, name: FormField.INSIGHT_ID, onChange: noop, value: selectedInsightOption, undefinedReadonlyPlaceholder: !editable, placeholder: !insightOptions.length ? "No Insight to add" : "Select", label: "Insight to calculate", restrictions: restrictions?.InsightId, items: insightOptions, classes: {
                    component: classNames({ [styles["field-noSources"]]: !insightOptions.length }),
                    label: styles["field-label"],
                } })),
        insightId && (React.createElement(React.Fragment, null,
            React.createElement(InsightInputSelect, { restrictions: restrictions?.InputSetId }),
            inputSetId && (React.createElement(InsightOutputSelect, { selectedParameters: selectedParameters, restrictions: restrictions?.Output }))))));
};
export default InsightParameterFormField;
